export default "__VITE_ASSET__C9Mv0zce__"